<template>
    <el-cascader
            :options="options"
            @change="onChange"
            v-loading="loading"
            v-bind="$attrs"
            :props="itemProps"
            ref="siteAreaCascader"
            placeholder="请选择区域"
            :disabled="disabled"
            v-model="data"
            :key="index"
    ></el-cascader>
</template>
<script>
    import { getSiteAreasBySiteId } from '@/service/site'
    export default{
        props: {
            value: {
                type: [Object, Number, String],
                default() {
                    return this.defaultValue()
                }
            },
            siteId: [Number, String],
            checkStrictly: {type: Boolean, default: true},
            emitPath: {type: Boolean, default: true},
        },
        data() {
            return {
                index: 0,
                data: null,
                areas: [],
                loading: false,
                options: [],
                disabled: true,
                itemProps: {
                    value: 'id',
                    label: 'name',
                    expandTrigger: 'hover',
                    checkStrictly: this.checkStrictly,
                    emitPath: this.emitPath
                }
            }
        },
        created() {
            this.search()
        },
        watch: {
            // value() {
            //     this.renderData()
            // },
            siteId() {
                this.onClean()
                this.search()
            }
        },
        methods: {
            defaultValue() {
                return {
                    district_id: 0,
                    section_id: 0,
                    area_id: 0,
                    street_id: 0
                }
            },
            search() {
                if (!!this.siteId === false) {
                    return
                }
                this.loading = true
                getSiteAreasBySiteId(this.siteId).then(response => {
                    this.areas = response
                    if (response.length > 0) {
                        let tree = this.toTree(response, 0)
                        if (tree.length > 0) {
                            this.options = tree[0].children
                        }
                    }
                    this.disabled = false
                    this.loading = false
                    this.renderData()
                }).catch(err => {
                    console.log(err)
                    this.loading = false
                })
            },
            // 线性数据转化为树。
            toTree(data, parent_id) {
                let tree = [];
                let temp;
                for (var i = 0; i < data.length; i++) {
                    if (data[i].up_id == parent_id) {
                        let obj = data[i];
                        temp = this.toTree(data, data[i].id);
                        if (temp.length > 0) {
                            obj.children = temp;
                        }
                        tree.push(obj);
                    }
                }
                return tree;
            },
            renderData() {
                // 不需要路径的，直接返回
                if (this.emitPath === false) {
                    if (/^\d+$/.test(this.value)) {
                        this.data = parseInt(this.value)
                    } else {
                        this.data = 0
                        this.$emit('input', this.renderValue())
                    }
                    return
                }
                this.data = []
                if (typeof this.value !== 'object') {
                    this.data = []
                    this.$emit('input', this.renderValue())
                    return
                }
                let temp = Object.values(this.value).filter(item => {return !!item})
                if (temp.length === 0 || this.areas.length === 0) {
                    this.$emit('input', this.renderValue())
                    return
                }
                for (let i = 0; i < temp.length; i++) {
                    this.areas.forEach(item => {
                        if (item.id == temp[i]) {
                            this.data.push(item.id)
                        }
                    })
                }
            },
            renderValue() {
                // 不需要路径的，直接返回
                if (this.emitPath === false) {
                    return this.data
                }
                let temp = this.defaultValue()
                let keys = {
                    '1': 'district_id',
                    '2': 'section_id',
                    '3': 'area_id',
                    '4': 'street_id'
                }
                if (this.data.length === 0 || this.areas.length === 0) {
                    return temp
                }
                this.areas.forEach(item => {
                    if (this.data.indexOf(item.id) !== -1) {
                        if (item.level != 0 && typeof keys[item.level] !== 'undefined') {
                            temp[keys[item.level]] = item.id
                        }
                    }
                })
                return temp;
            },
            onChange(item) {
                this.$emit('input', this.renderValue())
            },
            onClean() {
                this.index += 1
                this.data = this.emitPath ? [] : 0
                // this.data = null
                this.options = []
                this.areas = []
                this.disabled = true
                this.$emit('input', this.renderValue())
            }
        }
    }
</script>
